import LoadedFileList from './loaded-file-list';

export default LoadedFileList;
